import { client, gql } from './apollo';

const formatProperties = (fields) => {
    let properties = '';
    fields.forEach((field) => {
        properties += `
                {
                    ${field.id ? 'id: "' + field.id + '",' : ''}
                    property: "${field.property}",
                    typeId: "${field.type.value}",
                    nullable: ${field.nullable},
                    unique: ${field.unique},
                    ${field.length ? 'length: ' + field.length + ',' : ''}
                    ${field.defaultValue ? 'defaultValue: "' + field.defaultValue + '",' : ''}
                    ${field.foreignKey ? 'foreignKey: "' + field.foreignKey + '"' : ''}
                },
            `;
    });
    return properties;
};

export const GET_TABLE = gql`
    query table(
        $name: String!
        $limit: Int
        $offset: Int
        $orderBy: String
        $orderByDirection: GraphQLDirection
        $filter: [GraphQLFilter]
    ) {
        table(
            name: $name
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderByDirection: $orderByDirection
            filter: $filter
        )
    }
`;

export const GET_TABLES = gql`
    query ($offset: Int, $limit: Int) {
        tableSchemaList(offset: $offset, limit: $limit) {
            edges {
                node {
                    id
                    name
                    isJunction
                }
            }
        }
    }
`;

export const GET_TABLE_AND_PROPERTIES = gql`
    query tableSchema($id: ID!) {
        tableSchema(id: $id) {
            id
            name
            isJunction
            properties {
                edges {
                    node {
                        id
                        property
                        length
                        defaultValue
                        nullable
                        unique
                        foreignKey
                        type {
                            id
                            type
                        }
                    }
                }
            }
        }
    }
`;

export const GET_TABLES_AND_PROPERTIES = gql`
    query ($name: String, $offset: Int, $limit: Int) {
        tableSchemaList(name: $name, offset: $offset, limit: $limit) {
            edges {
                node {
                    id
                    name
                    isJunction
                    properties {
                        edges {
                            node {
                                id
                                property
                                length
                                defaultValue
                                nullable
                                unique
                                foreignKey
                                type {
                                    id
                                    type
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const createTable = async (table) => {
    const properties = formatProperties(table.fields);

    return await client.mutate({
        mutation: gql`
                mutation($name: String!, $isJunction: Boolean!) {
                    createTable(
                        table: {
                            name: $name, 
                            isJunction: $isJunction
                        }, 
                        properties: [
                            ${properties}
                        ]
                    ) {
                        table {
                            id,
                            name
                        }
                    }
                }
            `,
        variables: {
            name: table.name,
            isJunction: table.junction,
        },
    });
};

export const updateTable = async (table) => {
    const properties = formatProperties(table.fields);

    return await client.mutate({
        mutation: gql`
            mutation($id: ID!, $name: String!, $isJunction: Boolean!) {
                updateTable(table: {
                    id: $id,
                    name: $name,
                    isJunction: $isJunction
                },
                properties: [
                    ${properties}
                ]) {
                    table {
                        id,
                        name,
                        isJunction
                    }
                }
            }
        `,
        variables: {
            id: table.id,
            name: table.name,
            isJunction: table.junction,
        },
    });
};

export const deleteTable = async (id) => {
    return await client.mutate({
        mutation: gql`
            mutation ($id: ID!) {
                deleteTable(id: $id) {
                    tableName
                }
            }
        `,
        variables: {
            id: id,
        },
    });
};
